import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=ff72ab5a&scoped=true&"
import script from "./Step5.vue?vue&type=script&lang=ts&"
export * from "./Step5.vue?vue&type=script&lang=ts&"
import style0 from "./Step5.vue?vue&type=style&index=0&id=ff72ab5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff72ab5a",
  null
  
)

export default component.exports